export default "__VITE_ASSET__781cdfe0__"